// extracted by mini-css-extract-plugin
export default {"request":"RequestPage_request__RZ0dq","header":"RequestPage_header__eS30d"};